import { IIdObject } from '@common/interfaces/id-object.interface';
import {
    getDayjsFromCutOffTimeAndFixTimezone,
    getDeliveryDayFromDeliveryConfig,
    getStartDayFromDeliveryConfig,
} from '@common/utils/delivery-config/delivery-config.util';
import { getNow } from '@common/utils/get-now/now.util';
import { getValueFromDayOfWeekEnum } from '@src/shared/dictionary.hook';
import dayjs from 'dayjs';
import { IDeliveryConfiguration } from '../pack-house-generated-api';

export interface IDeliveryConfigDto extends Omit<IDeliveryConfiguration, 'id' | 'cutoff_time' | 'start_date'>, IIdObject {
    cutOffTime: Date | undefined;

    nextStartDate: Date;
    nextDeliveryDay: Date;
    startDate: Date;
    date: Date;
    deliveryDayOfWeek: string;
    customDeliveryDate: Date | undefined;
    toString: () => string;
    announcementObj:
        | {
              start: Date;
              end: Date;
              message: string;
          }
        | undefined;
}

export const createDeliveryConfigDto = (item: IDeliveryConfiguration): IDeliveryConfigDto => {
    const startDate = new Date(Math.round(((item as { start_date: number | undefined }).start_date || 0) * 1000));

    const cutOffTime = getDayjsFromCutOffTimeAndFixTimezone(item.cutoff_time).toDate();
    const date = dayjs(getNow()).isAfter(startDate) ? dayjs(getNow()).toDate() : startDate;
    const nextDeliveryDay = getDeliveryDayFromDeliveryConfig(dayjs(date).toDate(), item, cutOffTime);
    const customDeliveryDate = item.custom_delivery_date
        ? new Date(Math.round(Number(item.custom_delivery_date) * 1000))
        : undefined;

    const nextStartDate = dayjs(getStartDayFromDeliveryConfig(dayjs(date).toDate(), item, cutOffTime))
        .set('hours', cutOffTime.getHours())
        .set('minutes', cutOffTime.getMinutes())
        .toDate();

    const announcement = {
        start: dayjs((item.announcement?.period_start || 0) * 1000).toDate(),
        end: dayjs((item.announcement?.period_end || 0) * 1000).toDate(),
        message: item.announcement?.message || '',
    };

    return {
        ...item,
        id: item.id || '',
        startDate,
        date,
        cutOffTime,
        nextStartDate,
        nextDeliveryDay,
        deliveryDayOfWeek: getValueFromDayOfWeekEnum(item.delivery_day),
        customDeliveryDate,
        announcementObj: item.announcement ? announcement : undefined,

        toString: (): string => item.id || '',
    };
};
